import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonFab, IonFabButton, IonGrid, IonHeader, IonIcon, IonLoading, IonModal, IonPage, IonRow, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { chatbubbles, notifications } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { urlBase } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import Notificacoes from '../Notificacoes/Notificacoes';
import './Portfolio.css';
import ProgressiveImage from './ProgressiveImage';
import DefaultImage from './imgs/loading.gif';

const Portfolio: React.FC = () => {
  const history = useHistory();
  const [showLoadingPage, setShowLoadingPage] = useState(false);
  const [arrayCategorias, setArrayCategorias] = useState<any>([]);
  const { notificacoes, setNotificacoes } = useContext(MessageContext);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(false);
  });

  useEffect(() => {
    carregaCategoria();
  }, []);

  // Busca as categorias cadastradas para a empresa
  async function carregaCategoria() {
    const consultar = async () => {

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      setShowLoadingPage(true);
      const resp: Response = await fetch(urlBase.url + "/mobile/portfolio/".concat(window.localStorage.getItem("loja") || "").replaceAll(/#/g, '%23').concat("?opcao=categoria"),
        {
          method: urlBase.method,
          headers: [
            ["token", token],
            ["perfil", window.localStorage.getItem("perfil") || ""],
            ["marca", window.localStorage.getItem("marca") || ""],
          ],
          credentials: 'include'
        });

      await resp.json().then(async (res) => {
        if (resp.status === 400 || resp.status === 401) {
          setShowLoadingPage(false);
          history.replace("/login/");
        }

        if (res) {
          let lista = res.Items.sort((a: any, b: any) => a.destaque - b.destaque).reverse();
          setArrayCategorias(lista);
        }
      }).finally(() => {
        setShowLoadingPage(false);
      });
    }

    consultar();
  }

  async function closeModalNotificacoes() {
    setShowNotificacoes(false);
  }

  async function closeModalSimpleNotificacoes() {
    setShowNotificacoes(false);
  }


  return (
    <IonPage className="Portfolio">
      <IonHeader className="ion-no-border">
        <IonToolbar>

          <IonButtons slot="end">
            <IonButton onClick={() => {
              setShowNotificacoes(true);
            }}>
              <IonIcon slot="icon-only" icon={notifications} />
              <IonBadge id="cart-badge" color="danger">{notificacoes?.length}</IonBadge>
            </IonButton>
          </IonButtons>

        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={false}>

        <IonFab vertical="bottom" horizontal="end" slot="fixed" edge style={{ "bottom": "20px" }} hidden={window.localStorage.getItem("empresaTelefone") ? false : true}>

          <IonFabButton color="tertiary">
            <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (window.localStorage.getItem("empresaTelefone") || "")}>
              <IonIcon color="light" size="large" icon={chatbubbles} />
            </a>
          </IonFabButton>
        </IonFab>

        <div style={{ padding: '5px', paddingTop: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '0px', paddingBottom: '50px' }}>
            <div id='containerPortifolioCategorias' style={{ width: '100%', maxWidth: '1024px' }}>
              <IonGrid fixed={true}>
                <IonRow>
                  {
                    arrayCategorias.map((value: any) => (
                      <IonCol size={value.destaque ? "12" : "6"} size-md={value.destaque ? "12" : "6"} size-lg={value.destaque ? "12" : "6"}>
                        <IonCard onClick={() => { history.push("galeria", { categoria: btoa(value.sk), descricao: value.descricao }); }}
                          style={{ width: '100%', maxWidth: '1024px', height: value.destaque ? "350px" : "250px" }}>
                          {/*<img style={{ objectFit: 'cover', width: '100%', height: value.destaque ? "350px" : "250px" }} src={value.urlFile}></img>*/}
                          <ProgressiveImage imgSrc={value.urlFile} previewSrc={DefaultImage} width={'100%'} height={value.destaque ? "350px" : "250px"} />
                          <div style={{ position: 'absolute', top: 0, width: '100%', height: '100%' }}>
                            <IonCardContent style={{ textAlign: 'end', height: value.destaque ? "350px" : "250px", width: '100%', display: 'flex', alignItems: 'end', paddingBottom: '50px', justifyContent: 'right', color: '#fff', fontFamily: 'Open Sans', fontSize: '20px', fontWeight: 'bold', textShadow: '1px 1px 10px #000' }}>{value.descricao}</IonCardContent>
                          </div>
                        </IonCard>
                      </IonCol>
                    ))
                  }
                </IonRow>
              </IonGrid>
            </div>
          </div>
        </div>

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoadingPage}
          onDidDismiss={() => { setShowLoadingPage(false); }}
          spinner='circles'
        />

        <div className="content">
          <IonModal isOpen={showNotificacoes} onDidDismiss={() => { setShowNotificacoes(false); }}>
            <Notificacoes closeAction={closeModalNotificacoes} closeActionSimple={closeModalSimpleNotificacoes}></Notificacoes>
          </IonModal>

        </div>
      </IonContent >
    </IonPage >
  );
};

export default Portfolio;